<template>
    <user-form :user="{}"></user-form>
</template>

<script>
    import UserForm from '../components/UserForm'
    export default {
        name: 'users-create',

        components: {
            UserForm
        }
    }
</script>
